import $ from 'jquery';

export function parseDynamicFormElements($form) {
    if (!$form || !$form.length) {
        return;
    }

    $form
        .removeData('validator') /* added by the raw jquery.validate plugin */
        .removeData('unobtrusiveValidation'); /* added by the jquery unobtrusive plugin*/

    $.validator.setDefaults({
        ignore: []
    });
    $.validator.unobtrusive.parse($form);
}

export function isDynamicFormValid($form) {
    if (!$form || !$form.length) {
        return false;
    }

    parseDynamicFormElements($form);

    return $form.valid();
}

export function isValidShipDate(inputDate) {
    const shipDate = new Date(inputDate);
    const todaysDate = new Date();
    const sunday = 0;
    const saturday = 6;
    const maxYearThreshold = 5;

    shipDate.setHours(0, 0, 0, 0);
    todaysDate.setHours(0, 0, 0, 0);

    if (new RegExp(`${saturday}|${sunday}`).test(shipDate.getDay())) {
        return false;
    }

    if (shipDate.getFullYear() - todaysDate.getFullYear() > maxYearThreshold) {
        return false;
    }

    return shipDate >= todaysDate;
}
